











import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MultilineChip extends Vue {
  @Prop({ default: false }) readonly close!: boolean;
}
